import { render, staticRenderFns } from "./EditVehicleAssign.vue?vue&type=template&id=a0a163be"
import script from "./EditVehicleAssign.vue?vue&type=script&lang=js"
export * from "./EditVehicleAssign.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports